import React from 'react';
import { motion } from 'framer-motion';
export function TomosSection() {
  const tomos = [{
    emoji: '💜',
    title: 'Mamá e Hija',
    subtitle: '100 Citas especiales',
    desc: 'Actividades, conversaciones y momentos únicos para fortalecer el vínculo más especial entre mamá e hija. Incluye sección para fotos y recuerdos 📸',
    color: 'from-purple-500/20 to-purple-900/20',
    border: 'border-purple-500/30'
  }, {
    emoji: '💙',
    title: 'Mamá e Hijo',
    subtitle: '100 Citas especiales',
    desc: 'Ideas y experiencias diseñadas para conectar de verdad entre mamá e hijo. Incluye sección para fotos y recuerdos 📸',
    color: 'from-blue-500/20 to-blue-900/20',
    border: 'border-blue-500/30'
  }, {
    emoji: '💖',
    title: 'Papá e Hija',
    subtitle: '100 Citas especiales',
    desc: 'Momentos pensados para crear recuerdos inolvidables entre papá e hija. Incluye sección para fotos y recuerdos 📸',
    color: 'from-red-500/20 to-red-900/20',
    border: 'border-red-500/30'
  }, {
    emoji: '💚',
    title: 'Papá e Hijo',
    subtitle: '100 Citas especiales',
    desc: 'Aventuras, charlas y actividades para fortalecer la complicidad entre papá e hijo. Incluye sección para fotos y recuerdos 📸',
    color: 'from-emerald-500/20 to-emerald-900/20',
    border: 'border-emerald-500/30'
  }];
  return <section className="cv-auto py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-271">
      <div className="max-w-5xl mx-auto" data-id="element-272">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 md:mb-16" data-id="element-273">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-purple-500/20 text-purple-400 mb-6 shadow-[0_0_20px_rgba(168,85,247,0.2)] text-3xl" data-id="element-274">
            💖
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6" data-id="element-275">
            Pack 100 Citas Familiares
          </h2>
          <p className="text-lg md:text-xl text-slate-300 leading-relaxed max-w-3xl mx-auto mb-6" data-id="element-276">
            El primer sistema de citas familiares en español diseñado para que
            cualquier padre o madre — sin importar cuánto tiempo tenga — pueda
            crear momentos reales con sus hijos hoy mismo.
          </p>
          <div className="bg-navy-950 border border-navy-800 rounded-2xl p-6 max-w-2xl mx-auto text-left space-y-4" data-id="element-277">
            <p className="text-slate-300" data-id="element-278">
              <span className="text-purple-400 font-bold" data-id="element-279">
                Abrís el libro. Elegís una cita.
              </span>{' '}
              Y en menos de 20 minutos ya están viviendo algo que van a recordar
              siempre.
            </p>
            <p className="text-slate-300" data-id="element-280">
              No necesitás planificar. No necesitás gastar dinero extra. No
              necesitás ser creativo.
            </p>
            <p className="text-white font-bold text-lg" data-id="element-281">
              Solo elegís. Y empezás.
            </p>
          </div>
        </motion.div>

        <div className="text-center mb-10" data-id="element-282">
          <h3 className="text-2xl font-bold text-white" data-id="element-283">
            📚 Lo que incluye el Pack
          </h3>
        </div>

        {/* Tomo Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-284">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          delay: index * 0.05,
          duration: 0.3
        }} className={`bg-gradient-to-b ${tomo.color} border ${tomo.border} rounded-2xl p-5 md:p-6 backdrop-blur-sm hover:-translate-y-1 transition-transform duration-300 flex flex-col`} data-id="element-285">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-286">
                {tomo.emoji}
              </div>
              <h4 className="text-lg md:text-xl font-bold text-white mb-1" data-id="element-287">
                {tomo.title}
              </h4>
              <p className="text-xs md:text-sm font-semibold text-slate-300 mb-3 md:mb-4 pb-3 md:pb-4 border-b border-white/10" data-id="element-288">
                {tomo.subtitle}
              </p>
              <p className="text-slate-300 text-sm leading-relaxed flex-grow" data-id="element-289">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}